import React from "react";

const ThemeSelector = ({ selectedTheme, onSelect }) => {
  return (
    <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">
      <h5 className="fw-semibold mb-3">Select Theme Type</h5>

      <div className="d-flex gap-4">
        {["Default", "Custom"].map((opt) => (
          <div key={opt} className="form-check">
            <input
              className="form-check-input"
              type="radio"
              id={`theme-${opt}`}
              checked={selectedTheme === opt}
              onChange={() => onSelect(opt)}
            />
            <label htmlFor={`theme-${opt}`} className="form-check-label fw-medium">
              {opt === "Default" ? "Default Theme" : "Custom Theme"}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;